import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ContentProvider } from "@/contexts/ContentContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ProtectedRoute = ({ children }) => {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-black text-white font-mono-accent text-xs">
                Loading…
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <ContentProvider>
                        <Toaster
                            theme="dark"
                            position="top-right"
                            toastOptions={{
                                style: {
                                    background: "#0e0e0e",
                                    color: "#fff",
                                    border: "1px solid #27272a",
                                    borderRadius: 0,
                                    fontFamily: "Manrope, sans-serif",
                                },
                            }}
                        />
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </ContentProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
